import { Component, ViewChild, OnInit, AfterViewInit, TemplateRef, ChangeDetectorRef, Renderer2, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router,RouterModule } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CreateProjectService } from '../services/create-project.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RoleViewService } from '../services/role-view.service';
@Component({
  selector: 'app-table',
  standalone: true,
  imports:[CommonModule, RouterModule, MatIconModule, FormsModule],
  templateUrl: './table.component.html',
  styleUrl: './table.component.css'
})


export class TableComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('dialogTemplate') dialogTemplate!: TemplateRef<any>;
  dialogRef!: MatDialogRef<any>;

  projectName = '';
  projectCode = '';
  selectedCollection = '';
  selectedDepartments: string[] = [];
  selectedDocuments: string[] = [];
  displayedColumns: string[] = [
    'document', 'projectcode', 'department', 'createDate',
  ];

  ELEMENT_DATA = [
    { document: 'BCL013', documentUrl: '#', projectcode: '0436', collection: 'Target', department: 'BCL123', createDate: 'Feb 13, 2013', },
    { document: 'BCL014', documentUrl: '#', projectcode: '1822', collection: 'Target', department: 'BCL124', createDate: 'Nov 12, 2013', },
    { document: 'BCL015', documentUrl: '#', projectcode: '3489', collection: 'Target', department: 'BCL125', createDate: 'Aug 20, 2013', },
    { document: 'BCL016', documentUrl: '#', projectcode: '0437', collection: 'Target', department: 'BCL126', createDate: 'Jan 13, 2013', },
    { document: 'BCL017', documentUrl: '#', projectcode: '1823', collection: 'Target', department: 'BCL127', createDate: 'Mar 12, 2013', },
    { document: 'BCL018', documentUrl: '#', projectcode: '3490', collection: 'Target', department: 'BCL128', createDate: 'Jun 20, 2013', },

  ];
  filterValues: any = {
    document: '',
    project: '',
    collection: '',
    department: '',
    resp: '',
    dueDate: '',
    lastUpdated: '',
    status: ''
  };

  respOptions = ['John', 'Mike', 'Sara'];
  selection: any[] = [];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  private clickListener: any;
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  dropdownOpen = false;
  settingsOpen = false;
  selectedOption ='';
  selectedSettingsOption = '';
  currentUserRole = '';
  isSuperAdmin = false;
  isAdmin = false;


  constructor(private readonly cdr: ChangeDetectorRef, private readonly dialog: MatDialog, private readonly renderer: Renderer2,
     private readonly el: ElementRef, private readonly router: Router,  private readonly route: ActivatedRoute, private readonly createProjectService: CreateProjectService,
     private readonly roleViewService: RoleViewService) {

  }
  ngOnInit() {
    this.currentUserRole = this.roleViewService.getViewRole();
    const roleLower = this.currentUserRole.toLowerCase();
    this.isSuperAdmin = roleLower.includes('superadmin');
    this.isAdmin = roleLower.includes('admin') || this.isSuperAdmin;

    this.roleViewService.getViewRole$().subscribe(role => {
      this.currentUserRole = role;
      const roleLower = role.toLowerCase();
      this.isSuperAdmin = roleLower.includes('superadmin');
      this.isAdmin = roleLower.includes('admin') || this.isSuperAdmin;
      this.cdr.detectChanges();
    });

    this.dataSource.filterPredicate = (data, filter) => {
      return Object.values(data).some(val =>
        val.toString().toLowerCase().includes(filter)
      );
    };

    this.clickListener = this.renderer.listen('document', 'click', (event: Event) => {
      if (!this.el.nativeElement.contains(event.target)) {
        this.dropdownOpen = false; // Close the dropdown if clicked outside
      }
    });
  }

  ngOnDestroy() {
    if (this.clickListener) {
      this.clickListener(); // Remove the event listener
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.cdr.detectChanges();
  }

  openDialog(templateRef: any) {
    this.projectName = '';
    this.projectCode = '';
    this.selectedCollection = '';
    this.selectedDepartments = [];
    this.selectedDocuments = [];
    this.dialogRef = this.dialog.open(templateRef, {
      width: '800px',
      disableClose: true
    });
  }

  closeDialog(form?: NgForm) {
    if (form) {
      form.resetForm();
    }
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  submitForm(form: NgForm) {
    if (
      this.projectName &&
      this.projectCode &&
      this.selectedCollection &&
      this.selectedDepartments.length > 0 &&
      this.selectedDocuments.length > 0
    ) {
      console.info('New Project:', {
        collection: this.selectedCollection,
        name: this.projectName,
        code: this.projectCode,
        documents: this.selectedDocuments,
        departments: this.selectedDepartments

      });

      form.resetForm();

      this.closeDialog();
    } else {
      alert('Please fill all fields');
    }

  }

  applyGlobalFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  toggleRow(row: any) {
    const index = this.selection.indexOf(row);
    if (index === -1) {
      this.selection.push(row);
    } else {
      this.selection.splice(index, 1);
    }
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.dropdownOpen = !this.dropdownOpen;
  }

  closeDropdown() {
    this.dropdownOpen = false;
  }

  toggleSettings(event: Event) {
    event.stopPropagation();
    this.settingsOpen = !this.settingsOpen;
  }

  closeSettings() {
    this.settingsOpen = false;
  }

  // Handle selection of an option
  onOptionSelect(option: string) {
    this.selectedOption = option;
    console.info('Selected Option:', option);

    // Clear selections when navigating to manage-documents
    this.clearSelections();

    if (option === 'manage-documents') {
      this.router.navigate(['manage-documents']);
    }
    this.dropdownOpen = false;

  }

  onSettingSelect(option: string){
     this.selectedSettingsOption = option;
    
    // Clear selections when navigating to settings
    this.clearSelections();
    
    if(option ==='manage-project'){
      this.router.navigate(['manage-project']);
    }
    if(option ==='managecollections'){
      this.router.navigate(['managecollections']);
    }
    if(option ==='manage-document'){
      this.router.navigate(['manage-document']);
    }
    if(option ==='manage-report'){
      this.router.navigate(['manage-report']);
    }
    if(option ==='manage-custom-department'){
      this.router.navigate(['manage-custom-department']);
    }
    this.settingsOpen = false;
  }

  // Clear all selections from service
  clearSelections() {
    this.createProjectService.setSelectedCollection(null);
    this.createProjectService.setSelectedSubCollection([]);
    this.createProjectService.setSelectedProject(null);
    this.createProjectService.setSelectedEmail(null);
    this.createProjectService.setSelectedDepartment(null);
    this.createProjectService.setSelectedDepartmentId([]);
    this.createProjectService.setAllTeamMembers({});
    this.createProjectService.setProjectId(null);
  }
}
